// extracted by mini-css-extract-plugin
export default {"main":"Produtos_main__tIIng","produtoSection":"Produtos_produtoSection__2eHIp","produtosDiv":"Produtos_produtosDiv__gi0rK"};